import React, { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootState';
import { Dialog, OperationState } from '../../../store/appState';
import styled from 'styled-components/macro';
import * as Actions from '../../../store/actions';
import { AppPaths } from '../../../constants/urls';
import spaceVS from '../../../config/spaces/spaceVS';
import { useHistory, useLocation } from 'react-router-dom';
import { updateUrlParams } from '../../../utils/webPage';
import { ResourceStrings } from '../../../ResourceStrings';
import AnnouncementDetails from './AnnouncementDetails';
import { App } from '../../../app';
import { Breadcrumb, IBreadcrumbItem } from '@fluentui/react/lib/Breadcrumb';

export interface RecentFixesViewProps {
}

export default function RecentFixesView(): JSX.Element {
    const state = useSelector((state: RootState) => state.appState);
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        Actions.setDialog(Dialog.none);
        Actions.loadAnnouncements();
        Actions.loadIncidents();
    }, []);

    const urlParams: URLSearchParams = new URLSearchParams(location.search);
    updateUrlParams(urlParams, { space: spaceVS.id.toString() });

    function incidentClick(url: string): void {
        App.telemetry.postBusinessEvent("announcement-incident-clicked");
        App.openSafe(url);
    }

    function onBreadcrumbClick(ev?: React.MouseEvent<HTMLElement>, item?: IBreadcrumbItem): void {
        history.push(item.key);
    }

    const breadcrumb = <Breadcrumb items={[
        { text: "Home", key: AppPaths.home, onClick: onBreadcrumbClick },
        { text: "Recent fixes", key: AppPaths.fixes }
    ]} />;

    return (
        <Wrapper>
            {(state.incidentsLoadState === OperationState.Failed) && <>
                <div className="bar-loading"
                    aria-label={ResourceStrings.errorLoadingIncident(state.incidentErrorMessage)}>
                    {ResourceStrings.errorLoadingIncident(state.incidentErrorMessage)}
                </div>
            </>}
            {(state.incidentsLoadState === OperationState.Success && state.incidents.incidents.length > 0) && <>
                <div className="bar-problems">
                    <span tabIndex={0} aria-label={ResourceStrings.prefixIncidentText()}>{ResourceStrings.prefixIncidentText()}</span>
                    {(state.incidents.incidents || []).map((incident, i) => <Fragment key={i}>
                        <button
                            key={i}
                            className="a"
                            tabIndex={0}
                            aria-label={incident.title}
                            role="option"
                            onClick={(evt) => incidentClick(incident.url)}>
                            <span>{incident.title}</span>
                        </button>
                        {(i < state.incidents.incidents.length - 1) && <>
                            <span> ,&nbsp;</span>
                        </>}
                    </Fragment>
                    )}
                </div>
            </>}
            {(state.announcementsLoadState === OperationState.Executing) && <>
                <div className="bar-loading" aria-label={ResourceStrings.loadingAnnouncement()}>
                    {ResourceStrings.loadingAnnouncement()}
                </div>
            </>}
            {(state.announcementsLoadState === OperationState.Failed) && <>
                <div className="bar-loading" aria-label={ResourceStrings.errorLoadingAnnouncement(state.announcementErrorMessage)}>
                    {ResourceStrings.errorLoadingAnnouncement(state.announcementErrorMessage)}
                </div>
            </>}
            {(state.announcementsLoadState === OperationState.Success && (state.announcements.release != null || state.announcements.preview != null)) && <>
                <div className="bar-announcements">
                    <div className="tab-release">
                        {state.announcements.release && <AnnouncementDetails announcement={state.announcements.release} />}
                    </div>
                    <div className="tab-preview">
                        {state.announcements.preview && <AnnouncementDetails announcement={state.announcements.preview} />}
                    </div>
                </div>
            </>}
        </Wrapper >
    );
}

const Wrapper = styled.div`
    background-color: var(--color-background);
    display: flex;
    flex-direction: column;
    .myfeedback {
        padding: 0 var(--page-margin-horizontal);
    }

    .bar-announcements {
        background: var(--color-surface);
        padding: 2.5rem var(--page-margin-horizontal);
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        .tab-preview, .tab-release {
            flex: 1 0 auto;
            padding: 2rem;
        }
    }

`;
